// redux/actions/applicationActions.js
import axios from "axios";
// Removed toast and fileDownload imports

import {
  fetchApplicationsStart,
  fetchApplicationsSuccess,
  fetchApplicationsFailure,
  downloadApplicationStart,
  downloadApplicationSuccess,
  downloadApplicationFailure,
} from "../slicer/applicationsSlice";

const getToken = () =>
  document.cookie
    .split("; ")
    .find((row) => row.startsWith("accessToken="))
    ?.split("=")[1];

export const fetchApplications = (queryParams) => async (dispatch) => {
  dispatch(fetchApplicationsStart());
  try {
    const token = getToken();
    const apiParams = {
      page: queryParams.page,
      limit: queryParams.page_size,
      ...(queryParams.application_id && {
        application_id: queryParams.application_id,
      }),
      ...(queryParams.department_name && {
        department_name: queryParams.department_name,
      }),
      ...(queryParams.program_name && {
        program_name: queryParams.program_name,
      }),
    };

    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/getStudentApplications`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params: apiParams,
      }
    );

    console.log("API Response Data:", response.data);

    const paginationData = response.data.pagination || {
      total_pages: 1,
      current_page: 1,
    };

    dispatch(
      fetchApplicationsSuccess({
        data: response.data.data,
        totalPages: paginationData.total_pages,
        currentPage: paginationData.current_page,
      })
    );
  } catch (error) {
    console.error("Failed to fetch applications:", error);
    const errorMessage =
      error.response?.data?.message || error.message || "Failed to fetch applications";
    dispatch(fetchApplicationsFailure(errorMessage));
  }
};

// Thunk for downloading the main application file
export const downloadApplicationFile = (studentId) => async (dispatch) => {
  dispatch(downloadApplicationStart());
  try {
    const token = getToken();
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/downloadSApplicationFile/${studentId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob", // Ensure we get a binary response
      }
    );

    const link = document.createElement("a");
    const url = window.URL.createObjectURL(new Blob([response.data]));
    link.href = url;
    // Extract filename from response headers or default
    const contentDisposition = response.headers["content-disposition"];
    let fileName = `application_id_${studentId}.pdf`;
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
      if (filenameMatch && filenameMatch[1]) {
        fileName = filenameMatch[1];
      }
    }
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up
    window.URL.revokeObjectURL(url); // Clean up

    dispatch(downloadApplicationSuccess());
  } catch (error) {
    console.error("Failed to download application file", error);
    const errorMessage =
      error.response?.data?.message || error.message || "Failed to download application file";
    dispatch(downloadApplicationFailure(errorMessage));
  }
};

// Thunk for downloading individual documents by file path
export const fetchDocuments = (filePath, actualFileName = "document.pdf") => async (dispatch) => {
  dispatch(downloadApplicationStart());
  try {
    const token = getToken();
    const response = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/academicPage/download?file_path=${filePath}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        responseType: "blob", // Ensure we get a binary response
      }
    );

    const link = document.createElement("a");
    const url = window.URL.createObjectURL(new Blob([response.data]));
    link.href = url;
    // Extract filename from response headers or use provided actualFileName
    const contentDisposition = response.headers["content-disposition"];
    let fileNameToUse = actualFileName;
    if (contentDisposition) {
      const filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
      if (filenameMatch && filenameMatch[1]) {
        fileNameToUse = filenameMatch[1];
      }
    }
    link.setAttribute("download", fileNameToUse);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link); // Clean up
    window.URL.revokeObjectURL(url); // Clean up

    dispatch(downloadApplicationSuccess());
  } catch (error) {
    console.error("Failed to download document:", error);
    const errorMessage =
      error.response?.data?.message || error.message || "Failed to download document";
    dispatch(downloadApplicationFailure(errorMessage));
  }
};